import React from 'react';

const SalesFileContext = React.createContext();

export default SalesFileContext;
